"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import PromotionBannerConnector from "./PromotionBannerConnector";
import { returnActivePromotionBanner, returnFirstActivePromotionBanner } from "./PromotionBannerMethods";
import { PromotionBannerContext } from "./PromotionBannerContext";
const PromotionBannersWrapper = t0 => {
  const $ = _c(15);
  const {
    promoBannersData,
    siteConfigBannersData,
    lang
  } = t0;
  const {
    pageSpecificBanner,
    hideAllSitewide
  } = useContext(PromotionBannerContext);
  if (pageSpecificBanner != null) {
    let t1;
    if ($[0] !== pageSpecificBanner) {
      t1 = returnActivePromotionBanner(Array.isArray(pageSpecificBanner) ? pageSpecificBanner : [pageSpecificBanner]) || null;
      $[0] = pageSpecificBanner;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const activePromoBanners = t1;
    if (!activePromoBanners?.length) {
      return null;
    }
    let t2;
    if ($[2] !== activePromoBanners[0] || $[3] !== lang) {
      t2 = <PromotionBannerConnector promotionBanner={activePromoBanners[0]} lang={lang} />;
      $[2] = activePromoBanners[0];
      $[3] = lang;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (hideAllSitewide) {
    return null;
  }
  let t1;
  if ($[5] !== siteConfigBannersData) {
    t1 = returnFirstActivePromotionBanner(siteConfigBannersData);
    $[5] = siteConfigBannersData;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const siteConfigBanner = t1;
  if (siteConfigBanner) {
    let t2;
    if ($[7] !== lang || $[8] !== siteConfigBanner) {
      t2 = <PromotionBannerConnector promotionBanner={siteConfigBanner} lang={lang} />;
      $[7] = lang;
      $[8] = siteConfigBanner;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  if (!promoBannersData?.length) {
    return null;
  }
  let t2;
  if ($[10] !== promoBannersData) {
    t2 = returnActivePromotionBanner(promoBannersData) || null;
    $[10] = promoBannersData;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const activePromoBanners_0 = t2;
  if (!activePromoBanners_0?.length) {
    return null;
  }
  let t3;
  if ($[12] !== activePromoBanners_0[0] || $[13] !== lang) {
    t3 = <PromotionBannerConnector promotionBanner={activePromoBanners_0[0]} lang={lang} />;
    $[12] = activePromoBanners_0[0];
    $[13] = lang;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default PromotionBannersWrapper;